import { makeStateKey, TransferState } from '@angular/platform-browser';
import { CacheService } from '@ngx-cache/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID, NgModule, Optional, SkipSelf } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@ngx-cache/core';
class LocalStorageCacheService {
    constructor(platformId) {
        this.platformId = platformId;
        if (!isPlatformBrowser(platformId)) {
            throw new Error('LocalStorageCacheService is not supported outside `browser` platform!');
        }
    }
    get isEnabled() {
        if (!isPlatformBrowser(this.platformId)) {
            return false;
        }
        try {
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');
            return true;
        }
        catch (e) {
            return false;
        }
    }
    get keys() {
        if (!this.isEnabled) {
            return undefined;
        }
        const res = [];
        Object.keys(localStorage).forEach((key) => {
            res.push(key);
        });
        return res;
    }
    setItem(key, value) {
        if (!this.isEnabled) {
            return false;
        }
        try {
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        }
        catch (e) {
            return false;
        }
    }
    getItem(key) {
        if (!this.isEnabled) {
            return undefined;
        }
        const stored = localStorage.getItem(key);
        const cacheContent = stored ? stored : '{}';
        return JSON.parse(cacheContent);
    }
    removeItem(key, wild = false) {
        if (!this.isEnabled) {
            return;
        }
        localStorage.removeItem(key);
        if (wild) {
            for (const item of this.keys) {
                if (item.indexOf(key) === 0) {
                    localStorage.removeItem(item);
                }
            }
        }
    }
    clear() {
        if (!this.isEnabled) {
            return;
        }
        localStorage.clear();
    }
}
LocalStorageCacheService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];

class MemoryCacheService {
    constructor(platformId) {
        this.platformId = platformId;
        if (!this.isEnabled) {
            throw new Error('MemoryCacheService is not supported outside `browser` platform!');
        }
        this.memoryStorage = new Map();
    }
    get isEnabled() {
        return isPlatformBrowser(this.platformId);
    }
    get keys() {
        if (!this.isEnabled) {
            return undefined;
        }
        return Array.from(this.memoryStorage.keys());
    }
    setItem(key, value) {
        if (!this.isEnabled) {
            return false;
        }
        this.memoryStorage.set(key, value);
        return true;
    }
    getItem(key) {
        if (!this.isEnabled) {
            return undefined;
        }
        return this.memoryStorage.get(key);
    }
    removeItem(key, wild = false) {
        if (!this.isEnabled) {
            return;
        }
        this.memoryStorage.delete(key);
        if (wild) {
            for (const item of this.keys) {
                if (item.indexOf(key) === 0) {
                    this.memoryStorage.delete(item);
                }
            }
        }
    }
    clear() {
        if (!this.isEnabled) {
            return;
        }
        this.memoryStorage.clear();
    }
}
MemoryCacheService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];

class BrowserCacheModule {
    constructor(parentModule, transferState, cache) {
        this.transferState = transferState;
        this.cache = cache;
        if (parentModule) {
            throw new Error('BrowserCacheModule already loaded; import in BROWSER module only.');
        }
        const serverCache = this.getCacheValue();
        cache.rehydrate(serverCache);
    }
    static forRoot(configuredProviders) {
        return {
            ngModule: BrowserCacheModule,
            providers: configuredProviders
        };
    }
    getCacheValue() {
        const stateKey = makeStateKey(this.cache.key);
        const state = this.transferState.get(stateKey, {});
        if (state) {
            try {
                const serverCache = JSON.parse(state);
                this.transferState.remove(stateKey);
                return serverCache;
            }
            catch (e) {
            }
        }
        return {};
    }
}
BrowserCacheModule.ɵfac = function BrowserCacheModule_Factory(t) { return new (t || BrowserCacheModule)(ɵngcc0.ɵɵinject(BrowserCacheModule, 12), ɵngcc0.ɵɵinject(ɵngcc1.TransferState), ɵngcc0.ɵɵinject(ɵngcc2.CacheService)); };
BrowserCacheModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BrowserCacheModule });
BrowserCacheModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
BrowserCacheModule.ctorParameters = () => [
    { type: BrowserCacheModule, decorators: [{ type: Optional }, { type: SkipSelf }] },
    { type: TransferState },
    { type: CacheService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserCacheModule, [{
        type: NgModule
    }], function () { return [{ type: BrowserCacheModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc1.TransferState }, { type: ɵngcc2.CacheService }]; }, null); })();

export { BrowserCacheModule, LocalStorageCacheService, MemoryCacheService };

